export const COLUMNS = [
  "checkbox",
  "shareholder",
  "sharesOwnedAtUpvote",
  "upvotedAt",
];
